module.exports = __webpack_public_path__ + "static/media/banner.7a66ed0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/banner.mp4
// module id = cpq3
// module chunks = 0